module.exports = __webpack_public_path__ + "static/media/order-car.9ca2d1b4.svg";